import React from "react";

const EVENTS = [
  { time: "4:15 PM", title: "Guest arrival" },
  {
    time: "4:30 PM",
    title: "Ceremony",
    subtext: "The ceremony will be taking place outside weather permitting",
  },
  { time: "5:00 PM", title: "Cocktail hour" },
  { time: "6:00 PM", title: "Reception" },
  { time: "10:00 PM", title: "End of the event" },
];

export default function Timeline() {
  return (
    <section className="guest-page timeline-page">
      <p className="eyebrow">August 8, 2027</p>
      <h1>The day's timeline</h1>
      <p className="page-intro">
        We cannot wait to celebrate every moment with you.
      </p>

      <ol className="event-timeline">
        {EVENTS.map((event) => (
          <li className="timeline-event" key={event.time}>
            <div className="timeline-marker" aria-hidden="true" />
            <div className="timeline-content">
              <time>{event.time}</time>
              <h2>{event.title}</h2>
              {event.subtext && <p className="timeline-subtext">{event.subtext}</p>}
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}
